export default {

    state : () => ({
        steps       : [],
        parent      : null,
        rInd        : 1,
        doublePart  : null,
        solidPart   : null,
        width       : null,
        door        : null,
        doorPanel   : null,
        pallet      : {
            door  : 0,
            panel : 0
        },
        changeSizes : {
            door  : 0,
            panel : 0
        },
        lastChanges : {
            door  : 0,
            panel : 0
        },
        scheme      : ""
    }),

    actions : {
        GET_STEPS        : ( context ) =>
        {
            if(localStorage.steps && !context.state.parent)
            {
                context.state.steps       = JSON.parse(localStorage.steps);
                context.state.rInd        = JSON.parse(localStorage.rInd);
                context.state.door        = JSON.parse(localStorage.door);
                context.state.width       = JSON.parse(localStorage.width);
                context.state.doublePart  = JSON.parse(localStorage.doublePart);
                context.state.solidPart   = JSON.parse(localStorage.solidPart);
                context.state.doorPanel   = JSON.parse(localStorage.doorPanel);
                context.state.changeSizes = JSON.parse(localStorage.changeSizes);
                context.state.lastChanges = JSON.parse(localStorage.lastChanges);
                context.state.pallet      = JSON.parse(localStorage.pallet);
                return;
            }
            context.state.fromLocal = false;
            let formData            = new FormData();
            formData.append("parent", context.state.parent ? context.state.parent.id : null);
            fetch("/api/configurator/", {
                method : "POST",
                body   : formData
            })
            .then(response => response.json())
            .then(async resp =>
            {
                if(resp.success === true)
                {
                    let parentInd = -1;
                    let children  = [];
                    if(context.state.parent)
                    {
                        parentInd = context.state.steps.findIndex(
                            el =>
                            {
                                for(let elKey in el["ITEMS"])
                                {
                                    if(elKey === context.state.parent.id)
                                    {
                                        return elKey;
                                    }
                                }
                            }
                        );
                        if(context.state.steps[parentInd]["CHILDREN"])
                        {
                            for(let child of context.state.steps[parentInd]["CHILDREN"])
                            {
                                children.push(child);
                            }
                        }
                        if(children)
                        {
                            let keys = [];
                            for(let ind in context.state.steps)
                            {
                                for(let ind2 in context.state.steps[ind]["ITEMS"])
                                {
                                    if(children.some(
                                        ch => context.state.steps[ind]["ITEMS"][ind2]["ID"] === ch))
                                    {
                                        keys.push(ind);
                                    }
                                }
                            }
                            keys = keys.reverse();
                            keys = keys.filter(( item, i ) =>
                            {
                                return keys.indexOf(item) === i;
                            });
                            keys.forEach(el =>
                            {
                                context.state.steps.splice(el, 1);
                            });
                        }
                    }
                    for(let key in resp.data)
                    {
                        if(parentInd !== -1)
                        {
                            let grandParentInd = parentInd;
                            while(grandParentInd !== -1)
                            {
                                if(!context.state.steps[grandParentInd]["CHILDREN"])
                                {
                                    context.state.steps[grandParentInd]["CHILDREN"] = [];
                                }
                                for(let index in resp.data[key]["ITEMS"])
                                {
                                    let chIndex = context.state.steps[grandParentInd]["CHILDREN"].findIndex(
                                        el => el === index);
                                    chIndex === -1 ? context.state.steps[grandParentInd]["CHILDREN"].push(
                                        index) : void (0);
                                }
                                grandParentInd = context.state.steps.findIndex(el =>
                                    el["ITEMS"][context.state.steps[grandParentInd]["PARENT"]]
                                );
                            }
                        }
                        if(!resp.data[key]["SELECTED"])
                        {
                            resp.data[key]["SELECTED"] = {
                                name : null,
                                id   : null
                            };
                        }

                        resp.data[key]["RKEY"]     = context.state.rInd++;
                        resp.data[key]["showNext"] = false;

                        context.commit("PUSH_STEP", resp.data[key]);
                    }
                }
            });

        },
        SET_STEPS        : ( context ) =>
        {
            let er = false;
            context.state.steps.forEach(item =>
            {
                if(!item["SELECTED"].name)
                {
                    window.toast.error("Необходимо пройти все шаги конфигуратора.");
                    er = true;
                }
            });
            if(er)
            {
                return;
            }
            localStorage.steps         = JSON.stringify(context.state.steps);
            localStorage.readyForOrder = true;
            localStorage.rInd          = JSON.stringify(context.state.rInd);
            localStorage.parent        = JSON.stringify(context.state.parent);
            localStorage.changeSizes   = JSON.stringify(context.state.changeSizes);
            localStorage.lastChanges   = JSON.stringify(context.state.lastChanges);
            localStorage.pallet        = JSON.stringify(context.state.pallet);
            localStorage.doublePart    = JSON.stringify(context.state.doublePart);
            localStorage.doorPanel     = JSON.stringify(context.state.doorPanel);
            localStorage.solidPart     = JSON.stringify(context.state.solidPart);
            localStorage.width         = JSON.stringify(context.state.width);
            localStorage.door          = JSON.stringify(context.state.door);
            location.href              = "/configuration/";
        },
        SET_PARENT       : ( context, payload ) =>
        {
            context.commit("UPDATE_PARENT", payload);
        },
        SET_SELECT       : ( context, payload ) =>
        {
            context.commit("UPDATE_SELECT", payload);
        },
        SET_DOUBLE_PART  : ( context, payload ) =>
        {
            context.commit("UPDATE_DOUBLE_PART", payload);
        },
        SET_PANEL        : ( context, payload ) =>
        {
            context.commit("UPDATE_PANEL", payload);
        },
        SET_DOOR         : ( context, payload ) =>
        {
            context.commit("UPDATE_DOOR", payload);
        },
        SET_PALLET_PANEL : ( context, payload ) =>
        {
            context.commit("UPDATE_PALLET_PANEL", payload);
        },
        SET_PALLET_DOOR  : ( context, payload ) =>
        {
            context.commit("UPDATE_PALLET_DOOR", payload);
        },
        CLEAR_ALL        : ( context ) =>
        {
            context.commit("CLEAR");
            context.dispatch("GET_STEPS");
        }
    },

    mutations : {
        PUSH_STEP           : ( state, step ) =>
        {
            if(state.steps.length === 0)
            {
                state.steps.push(step);
            }
            else
            {
                let index = 0;
                if(state.parent)
                {
                    for(let key in state.steps)
                    {
                        if(state.steps[key]["SUPER_PARENT"] === state.parent.id && parseInt(
                            state.steps[key].SORT) <= parseInt(step.SORT))
                        {
                            index = key;
                        }
                    }

                    if(!index)
                    {
                        for(let key in state.steps)
                        {
                            if(state.steps[key]["ITEMS"][state.parent.id])
                            {
                                index = key;
                            }
                        }
                    }
                }
                else
                {
                    for(let key in state.steps)
                    {
                        if(state.steps[key].SUPER_PARENT === "root" && parseInt(state.steps[key].SORT) <= parseInt(
                            step.SORT))
                        {
                            index = parseInt(key);
                        }
                    }
                }


                index++;
                state.steps.splice(index, 0, step);
            }
        },
        UPDATE_PARENT       : ( state, parent ) =>
        {
            state.parent = parent;
        },
        UPDATE_SELECT       : ( state, selectedItem ) =>
        {
            state.steps[selectedItem.index]["SELECTED"].name = selectedItem.name;
            state.steps[selectedItem.index]["SELECTED"].id   = selectedItem.id;
            for(const key in state.steps)
            {
                if(key >= selectedItem.index)
                {
                    state.steps[selectedItem.index]["SELECTED"].name = selectedItem.name;
                    state.steps[selectedItem.index]["SELECTED"].id   = selectedItem.id;
                    state.steps[key]["showNext"]                     = false;
                }
            }
            if(state.steps[selectedItem.index]["RESET_SIZES"] === "Y")
            {
                localStorage.removeItem("pallet");
                localStorage.removeItem("changeSizes");
                localStorage.removeItem("lastChanges");
                localStorage.removeItem("doublePart");
                localStorage.removeItem("solidPart");
                localStorage.removeItem("doorPanel");
                localStorage.removeItem("width");
                localStorage.removeItem("door");
                localStorage.removeItem("doorPanelInfo");
                state.doublePart  = null;
                state.solidPart   = null;
                state.doorPanel   = null;
                state.width       = null;
                state.door        = null;
                state.changeSizes = {
                    door  : 0,
                    panel : 0
                };
                state.lastChanges = {
                    door  : 0,
                    panel : 0
                };
                state.pallet      = {
                    door  : 0,
                    panel : 0
                };
            }
        },
        UPDATE_DOOR         : ( state, door ) =>
        {
            state.changeSizes.door = door;
        },
        UPDATE_PANEL        : ( state, panel ) =>
        {
            state.changeSizes.panel = panel;
        },
        UPDATE_PALLET_DOOR  : ( state, door ) =>
        {
            state.pallet.door = Number(door);
        },
        UPDATE_PALLET_PANEL : ( state, panel ) =>
        {
            state.pallet.panel = Number(panel);
        },
        UPDATE_DOUBLE_PART  : ( state, doublePart ) =>
        {
            state.changeSizes.doublePart = doublePart;
        },
        UPDATE_DOOR_PANEL   : ( state, doorPanel ) =>
        {
            state.changeSizes.doorPanel = doorPanel;
        },
        CLEAR               : ( state ) =>
        {
            localStorage.removeItem("steps");
            localStorage.removeItem("readyForOrder");
            localStorage.removeItem("rInd");
            localStorage.removeItem("parent");
            localStorage.removeItem("changeSizes");
            localStorage.removeItem("pallet");
            localStorage.removeItem("lastChanges");
            localStorage.removeItem("doublePart");
            localStorage.removeItem("solidPart");
            localStorage.removeItem("doorPanel");
            localStorage.removeItem("width");
            localStorage.removeItem("door");
            localStorage.removeItem("doorPanelInfo");
            state.steps       = [];
            state.parent      = null;
            state.rInd        = 1;
            state.doublePart  = null;
            state.solidPart   = null;
            state.doorPanel   = null;
            state.width       = null;
            state.door        = null;
            state.changeSizes = {
                door  : 0,
                panel : 0
            };
            state.lastChanges = {
                door  : 0,
                panel : 0
            };
            state.pallet      = {
                door  : 0,
                panel : 0
            };
        }
    },

    getters : {}

};